import { api } from '../../config/api'
import {
  SHOPPING,
  POPULAR_SHOPPING,
  SHOPPING_DETAILS
} from '../../actions/actionTypes'

export const getShopping = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().shopping.list[lang].lastUpdate || !getState().shopping.list[lang].data.length) {
    dispatch({ type: SHOPPING.REQUEST })
    return (
      fetch(api.shopping+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: SHOPPING.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: SHOPPING.FAILURE, error: err })
      })
    )
  }
}

export const getPoppularShopping = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().shopping.popular[lang].lastUpdate || !getState().shopping.popular[lang].data.length) {
    dispatch({ type: POPULAR_SHOPPING.REQUEST })
    return (
      fetch(api.shoppingPopular+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: POPULAR_SHOPPING.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: POPULAR_SHOPPING.FAILURE, error: err })
      })
    )
  }
}

export const getShoppingDataById = (id) => (dispatch, getState) => {
  const { lang } = getState()
  dispatch({ type: SHOPPING_DETAILS.REQUEST, lang })
  return (
    fetch(api.shopping+'/'+id+'?language='+lang)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: SHOPPING_DETAILS.SUCCESS, data: res, lang })
    })
    .catch((err) => {
      dispatch({ type: SHOPPING_DETAILS.FAILURE, error: err })
    })
  )
}


// WEBPACK FOOTER //
// ./src/containers/Shopping/actions.js